export default __webpack_public_path__ + "static/media/raydditlogo.1009fb5b.png";